export const loadComponentAsync = importComponent =>
  (nextState, callback) => {
    importComponent()
      .then(component => {
        callback(null, component.default);
      });
  };

export const loadComponentsAsync = (importComponents, readyComponents) =>
  (location, callback) => {
    const componentsPromises = _.map(_.values(importComponents), importComponent => importComponent());
    const componentKeys = _.keys(importComponents);

    Promise.all(componentsPromises)
      .then(componentModules => {
        callback(null, {
          ..._.zipObject(componentKeys, _.map(componentModules, 'default')),
          ...readyComponents,
        });
      });
  };



// WEBPACK FOOTER //
// ./src/shared/utils/async-components.js